(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coatday-cart-drawer"]) return;
  try {
    
(() => {
 const drawer = document.getElementById('CoatdayCart');
 if (!drawer || typeof drawer.showModal !== 'function') return;
 let opener;
 let busy = false;
 const status = drawer.querySelector('[data-cart-status]');
 const checkout = drawer.querySelector('[data-drawer-checkout]');
 const root = drawer.dataset.root;
 const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency || drawer.dataset.currency}).format(amount / 100);
 const show = () => { if (!drawer.open) { opener = document.activeElement; drawer.showModal(); } };
 const render = (cart) => {
   const list = drawer.querySelector('[data-cart-items]');
   list.replaceChildren();
   for (const item of cart.items) {
     const line = document.createElement('article'); line.className = 'cd-cart-line';
     if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = item.product_title; line.append(img); }
     const info = document.createElement('div');
     const name = document.createElement('a'); name.href = item.url; name.textContent = item.product_title; info.append(name);
     if (item.variant_title && item.variant_title !== 'Default Title') { const v = document.createElement('p'); v.textContent = item.variant_title; info.append(v); }
     const qty = document.createElement('p'); qty.textContent = drawer.dataset.quantity + ': ' + item.quantity; info.append(qty);
     const price = document.createElement('p'); price.textContent = money(item.final_line_price, cart.currency); info.append(price);
     const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.removeLine = item.key; remove.textContent = drawer.dataset.remove; info.append(remove);
     line.append(info); list.append(line);
   }
   if (!cart.item_count) { const empty = document.createElement('p'); empty.textContent = drawer.dataset.empty; list.append(empty); }
   drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
   checkout.disabled = cart.item_count === 0;
   document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
 };
 const load = async () => { const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}}); if (!response.ok) throw new Error(drawer.dataset.error); render(await response.json()); };
 drawer.addEventListener('close', () => opener?.focus());
 document.addEventListener('click', async event => {
   if (event.target.closest('[data-cart-close]')) { drawer.close(); return; }
   if (event.target === drawer) { const r = drawer.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) drawer.close(); return; }
   if (event.target.closest('[data-cart-open]')) {
     event.preventDefault(); show(); status.textContent = ''; checkout.disabled = true;
     try { await load(); } catch (error) { status.textContent = drawer.dataset.error; } return;
   }
   const remove = event.target.closest('[data-remove-line]');
   if (!remove || busy) return;
   busy = true; remove.disabled = true; checkout.disabled = true; status.textContent = '';
   try { const response = await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:remove.dataset.removeLine,quantity:0})}); const cart = await response.json(); if (!response.ok) throw new Error(cart.description || drawer.dataset.error); render(cart); }
   catch (error) { status.textContent = error.message; remove.disabled = false; }
   finally { busy = false; }
 });
 document.addEventListener('submit', async event => {
   const form = event.target;
   if (!(form instanceof HTMLFormElement) || !new URL(form.action, location.href).pathname.endsWith('/cart/add')) return;
   event.preventDefault(); if (busy) return;
   busy = true; const button = event.submitter || form.querySelector('[type="submit"]'); if (button) button.disabled = true;
   const data = new FormData(form); if (!data.has('quantity')) data.set('quantity','1');
   show(); status.textContent = ''; checkout.disabled = true;
   try { const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:data}); const result = await response.json(); if (!response.ok) throw new Error(result.description || drawer.dataset.error); await load(); }
   catch (error) { status.textContent = error.message || drawer.dataset.error; }
   finally { busy = false; if (button) button.disabled = false; }
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grooming-kit"] && !Shopify.designMode) return;
  try {
    
if (!window.coatdayEventsInstalled) {
  window.coatdayEventsInstalled = true;
  document.addEventListener('click', function(event) {
    const stickyBuy = event.target.closest('[data-sticky-buy]');
    if (stickyBuy) {
      const buy = document.querySelector('[data-main-buy]');
      if (buy && !buy.disabled) buy.click();
      else document.getElementById('kit')?.scrollIntoView({behavior:'smooth'});
      return;
    }
    const button = event.target.closest('[data-media-select]');
    if (!button) return;
    const gallery = button.closest('[data-coatday-gallery]');
    gallery.querySelectorAll('[data-media-panel]').forEach(function(panel) {
      panel.hidden = panel.dataset.mediaPanel !== button.dataset.mediaSelect;
      if (panel.hidden) panel.querySelectorAll('video').forEach(function(video) { video.pause(); });
    });
    gallery.querySelectorAll('[data-media-select]').forEach(function(control) { control.setAttribute('aria-pressed', String(control === button)); });
  });
  document.addEventListener('change', function(event) {
    const option = event.target.closest('[data-variant-radio]');
    if (!option) return;
    const root = option.closest('[data-coatday-product]');
    const price = root.querySelector('[data-current-price]');
    if (price) { const source = option.closest('.offer-card').querySelector('.offer-price'); price.replaceChildren(...Array.from(source.childNodes, node => node.cloneNode(true))); }
    const stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = option.dataset.price;
  });
}

  } catch(e) { console.error(e); }
})();
})();
